import type { FileOrderByField, FileSortOrder, FileUploadFragment } from "@qw/graphql";
import { createContext, useContext } from "react";

export interface MimeTypeCount {
  mimeType: string;
  count: number;
}

export enum FileStatus {
  All = "All",
  Active = "Active",
  Deleted = "Deleted",
}

export enum FileSource {
  All = "All",
  Null = "Null",
  CORRESPONDENCE_PDF = "CORRESPONDENCE_PDF",
  EMAIL_ATTACHMENT = "EMAIL_ATTACHMENT",
  GENERATE_ACORD = "GENERATE_ACORD",
  GENERATED_SOV = "GENERATED_SOV",
  INSCIPHER_STATE_DOCUMENT = "INSCIPHER_STATE_DOCUMENT",
  LOSS_RUN_DOC = "LOSS_RUN_DOC",
  MANUAL_UPLOAD = "MANUAL_UPLOAD",
  POLICY_PDF = "POLICY_PDF",
  QUOTE_PDF = "QUOTE_PDF",
  RAW_QUOTE_PDF = "RAW_QUOTE_PDF",
  REDACTED_QUOTE = "REDACTED_QUOTE",
}

// Re-export the generated enums for convenience
export { FileOrderByField, FileSortOrder } from "@qw/graphql";

interface FilesContextValue {
  files: FileUploadFragment[];
  fileSource: FileSource;
  headers: HeadersInit;
  loading: boolean;
  mimeType: string | null;
  mimeTypeCounts?: MimeTypeCount[];
  mimeTypesLoading: boolean;
  orderBy: FileOrderByField;
  selectedFile: FileUploadFragment | undefined;
  sort: FileSortOrder;
  status: FileStatus;
  setFileSource: (value: FileSource) => void;
  setMimeType: (value: string | null) => void;
  setOrderBy: (value: FileOrderByField) => void;
  setSelectedFile: React.Dispatch<React.SetStateAction<FileUploadFragment | undefined>>;
  setSort: (value: FileSortOrder) => void;
  setStatus: (value: FileStatus) => void;
}

export const FilesContext = createContext<FilesContextValue | null>(null);

export const useFiles = () => {
  const context = useContext(FilesContext);

  if (!context) {
    throw new Error("useFiles must be used within a FilesProvider");
  }

  return context;
};
